// extracted by mini-css-extract-plugin
module.exports = {"chip":"styles_chip__VQILV","active":"styles_active__k16yj"};